<template>
  <a @click="openPlace" class="block bg-white mr-4 border border-section_border rounded p-2 w-48 overflow-hidden">
    <progressive-img
      :src="duration.place.image"
      :fallback="require('@/assets/images/no-image.jpg')"
      class="w-full h-24"
    />
    <h2 class="mt-2 text-sm font-bold truncate">{{ duration.place.name }}</h2>
    <p class="text-btn_secondary text-xs">
      {{ $t('tour_duration_label', { label: label, duration: duration.amount }) }}
    </p>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    duration: {
      type: Object
    }
  },
  methods: {
    openPlace: function () {
      this.$store.dispatch('drawer/openPlace', { place: this.duration.place, full: true })
    }
  },
  computed: {
    ...mapGetters({
      from: 'map/getFrom',
    }),
    label: function () {
      if (this.from.route) {
        return this.$t('tour_duration_before_label')
      } else {
        return this.$t('tour_duration_current_label')
      }
    }
  }
}
</script>
